import React from "react";

const MemberCardBenifits = () => {

    return (
        <>
            <div className="member__card">
                <h2 className="text-jost-sb-24">Your clubs membership details:</h2>
                <div className="member__card-detail">
                    <h2 className=" text-jost-sb-22">Account Opened:</h2>
                    <span>01 May 2021</span>
                </div>
                <div className="member__card-detail">
                    <h2 className=" text-jost-sb-22-rd">Account Closing Date:</h2>
                    <span>01 May 2021</span>
                    </div>
                    <div className="member__card-detail">
                        <h2 className=" text-jost-sb-22">Payment Frequency: </h2>
                        <span>Monthly Instalments</span>
                    </div>
                    <div className="member__card-detail">
                        <h2 className=" text-jost-sb-22">Payment Method: </h2>
                        <div className="member__card-detail-method">
                        <span>Card Ending 0009</span>
                        <span className="text-ops-rg-16-lg ">Change</span>
                        </div>
                    </div>


            </div>


        </>
    );
};
export default MemberCardBenifits;